import { AlertRoleMappingModel } from '../../models/alerts/alertRoleModels';
import * as _ from 'lodash';

import angular = require("angular");
import {apsCommands} from "../../shared/dto/aps.commands";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import HttpServiceName, {HttpService} from "../http/http.service";
import {Endpoints} from "../../shared/config/constant.module";

let requires = [HttpServiceName];

export interface AlertRoleService {
    getalertroles(): angular.IPromise<AlertRoleMappingModel[]>;
    postalertroles(command: apsCommands.Savealertroles): angular.IPromise<any>;
}
  
class AlertRolesSvc implements AlertRoleService {
    private httpService: HttpService;

    constructor(httpService: HttpService) {
        this.httpService= httpService;
    }

    getalertroles(): angular.IPromise<AlertRoleMappingModel[]> {
        return this.httpService.get(Endpoints.ALERTROLES)
            .then((alertRoles: apsViewModels.AlertRoleMapping[]) => {
                return _.map(alertRoles, alertRole => new AlertRoleMappingModel(alertRole));
            });        
    }
    postalertroles(command: apsCommands.Savealertroles): angular.IPromise<any> {
        return this.httpService.post(Endpoints.ALERTROLES, command);    
    }
}

export default angular.module('aps.services.alertRoleservice', requires)
    .service('AlertRolesService', AlertRolesSvc)
    .name;  


// WEBPACK FOOTER //
// ./src/app/services/alertRoles/alertRoleService.ts